import React from 'react'

const PostContext = React.createContext<any>({})

export const PostProvider = ({post, children}: any) => {
	return (
		<PostContext.Provider value={post}>
			{children}
		</PostContext.Provider>
	)
}
export const PostConsumer = PostContext.Consumer
export default PostContext
